import React from 'react';
import { number, func } from 'prop-types';

// Import components
import { Root } from './styles';
import GradientButton from './GradientButton';

// Import assets
import { ReactComponent as PlayIcon } from 'assets/icons/vod_play.svg';

// Import hooks
import { usePreviewButton } from './hooks';

export function PreviewButton({ watchPreview, width, height, GTMEvent }) {
	const { ref, handleClick, buttonText } = usePreviewButton({
		watchPreview,
		GTMEvent
	});

	return (
		<Root onClick={handleClick} width={width} height={height} ref={ref}>
			<GradientButton
				text={buttonText}
				icon={<PlayIcon stroke="#fff" height={18} />}
				ref={ref}
			/>
		</Root>
	);
}

PreviewButton.defaultProps = {
	width: 189,
	height: 59
};

PreviewButton.propTypes = {
	width: number,
	height: number,
	watchPreview: func,
	GTMEvent: func
};
